module.exports = __webpack_public_path__ + "static/media/indy-logo-small.c451f9a7.jpg";